import React from "react";
import { connect } from "react-redux";

import { deleteFeaturedMan } from "../../../redux/actions/featuredManufacturers";
import styles from "../../../styles/Components/Shared/ConfirmForm.module.css";

const DeleteDialog = ({
  deleteFeaturedMan,
  handleClose,
  featuredManufacturer: { selectedManufacturer },
}) => {
  const handleDelete = (e) => {
    e.preventDefault();
    deleteFeaturedMan(selectedManufacturer.feature_manufacturer_id);
    handleClose();
  };
  return (
    <>
      <div className={styles.confirm_modal_container}>
          <p className={styles.confirm_modal_header}>DELETE MANUFACTURER FEATURED PRODUCT</p>
          <div>
              <p className={styles.confirm_modal_text}>Are you sure you want to delete {selectedManufacturer.Manufacturer.name}'s featured products?</p>
              <p className={styles.confirm_modal_bold}>This cannot be undone.</p>
          </div>
          <div className={styles.confirm_modal_button_container}>
              <button  className={styles.confirm_modal_buttons} onClick={handleClose}>Cancel</button>
              <button  className={styles.confirm_modal_buttons} onClick={handleDelete}>Delete</button>
          </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  featuredManufacturer: state.featuredManufacturer,
});

export default connect(mapStateToProps, { deleteFeaturedMan })(DeleteDialog);
